module.exports = __webpack_public_path__ + "assets/img/61a1b0b4712d4c9246e3e1e699ca3a42.svg";